var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ies-form-field", { attrs: { field: _vm.field } }, [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.input,
          expression: "input",
        },
      ],
      attrs: {
        name: this.field.fieldName,
        type: "number",
        required: this.field.required,
        disabled: this.field.disabled,
      },
      domProps: { value: _vm.input },
      on: {
        change: function ($event) {
          return _vm.updateField()
        },
        input: function ($event) {
          if ($event.target.composing) return
          _vm.input = $event.target.value
        },
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }